angular
  .module('common.directives')
  .directive('edgeDangerousDrivingReport', function () {
    return {
      scope: {
        edge: '=',
        eventSearch: '='
      },
      templateUrl:
        './templates/edgeDangerousDrivingReports.view.html?t=' + webpackHash,
      link: function ($scope, $element, attrs) {},
      controller: 'edgeDangerousDrivingController'
    }
  })
